var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    transform: "translate(-732 -480)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 383,
    height: 852,
    transform: "translate(-46 -350)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26 -17C-26 -22.5229 -21.5228 -27 -16 -27H307C312.523 -27 317 -22.5228 317 -17V234C317 239.523 312.523 244 307 244H-16C-21.5228 244 -26 239.523 -26 234V-17Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -17,
    width: 323,
    height: 91,
    rx: 5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 12.1993H4.625V13.3546H0.875V12.1993H2.125V0.645996H3.375V12.1993ZM10.3562 4.68965L12.0375 2.09594C12.0938 2.00823 12.1239 1.90833 12.1249 1.80637C12.1258 1.70442 12.0976 1.60404 12.043 1.51544C11.9884 1.42684 11.9094 1.35318 11.814 1.30193C11.7187 1.25068 11.6103 1.22368 11.5 1.22366H4V8.15565H11.5C11.6103 8.15563 11.7187 8.12862 11.814 8.07738C11.9094 8.02613 11.9884 7.95247 12.043 7.86387C12.0976 7.77527 12.1258 7.67489 12.1249 7.57294C12.1239 7.47098 12.0938 7.37108 12.0375 7.28337L10.3562 4.68965Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -66,
    y: -370,
    width: 423,
    height: 892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "white",
    transform: "translate(-732 -480)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.03108b991b7d741eef2470431f2d330f.svg";
export { ForwardRef as ReactComponent };